import { useTeamsGetTeamGroups } from 'api/teams/teams';
import { useMemo } from 'react';

const useTeamGroups = () => {
  const { data: teamGroups = [] } = useTeamsGetTeamGroups();
  const teamGroupsById = useMemo(() => {
    return new Map(teamGroups.map((e) => [e.id, e]));
  }, [teamGroups]);
  return { teamGroups, teamGroupsById };
};

export default useTeamGroups;
